import React from 'react';
import {Box, Button, Grid, IconButton, Typography} from "@mui/material";
import {NavLink} from "react-router-dom";
import snap from '../../../../assets/images/snap.jpg';
import {IS_AUTH} from "../../../../redux/action/type.action";
import {getLastEventApi} from "../../../../api/ClientApi";
import {GetState} from "../../../../redux/reduxhelper";
import {useNavigate} from "react-router";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {useQuery} from "react-query";
import Loading from "../../../../components/Site/Loading/Loading";
import {fixStringToHtml} from "../../../../tools/helper";

const LastEvent = () => {
    const isAuth = GetState(IS_AUTH, false)
    const navigate = useNavigate();

    const getLastEvent = async () => {
        try {
            const res = await getLastEventApi()
            return res?.data?.data


        } catch (e) {
            // console.log(e,"there is a problem")
        }
    }

    const {
        isLoading,
        data: lastEvent,
    } = useQuery(['last_event'], getLastEvent);

    if (isLoading) return <Loading/>;
    return (
        <Box sx={{
            width: '100vw',
            display: 'flex',
            flexDirection: "column",
            minHeight: '600px',
            alignItems: 'center',
            justifyContent: 'center',
            my: 2

        }}>
            <Grid container sx={{
                display: "flex",
                maxWidth: '1300px',
                px: 2,
                justifyContent: "space-between",
                alignItems: "center",
                mt: 5,
                mb: 2,
                marginX: 'auto'
            }}
                  data-aos="fade-up"
                  data-aos-anchor-placement="bottom-bottom">
                <Typography variant={"h5"} sx={{fontWeight: 700}}>
                    ایونت اخیر
                </Typography>
                <Typography variant={"h6"}>
                    <NavLink to={"/events"} style={{
                        textDecoration: "none",
                        ":hover": {color: "#8062ba"},
                        fontWeight: 600,
                    }}>مشاهده
                        همه</NavLink>
                </Typography>
                {isAuth && <Box sx={{textAlign: "right", width: "100%"}}>
                    <IconButton sx={{color: "#592EA9", cursor: "pointer"}}
                                onClick={() => navigate('admin/dashboard/home')}>
                        <EditOutlinedIcon/>
                    </IconButton>
                </Box>}
            </Grid>


            <Grid container sx={{
                display: 'flex',
                alignItems: 'center',
                maxWidth: '1300px',
                marginX: 2,
                padding: '40px',
                border: '1px solid #C5C6D0',
                overflowX: 'hidden'
            }}>

                <Grid data-aos="fade-left"
                      data-aos-duration="2000"
                      data-aos-once="true"
                      data-aos-delay="000" item xs={12} md={6} sx={{'& .img': {width: {xs: '100%', md: '95%'}}}}>
                    <img className={'img'} src={snap} alt="My Team"/>
                </Grid>

                <Grid item xs={12} md={6} data-aos="fade-right"
                      data-aos-duration="2000"
                      data-aos-once="true"
                      data-aos-delay="000">
                    <Typography variant={'h4'} sx={{
                        fontWeight: 800
                    }}>
                        {lastEvent?.title1}
                    </Typography>
                    <Typography variant={'h5'} sx={{color: "#592EA9", fontWeight: 800, my: 2}}>
                        {lastEvent?.title2}
                    </Typography>
                    <Typography variant="h6" sx={{
                        color: "#6D6E76", opacity: '0.8',
                        paddingBottom: '30px',
                    }} dangerouslySetInnerHTML={{__html: fixStringToHtml(lastEvent?.description)}}/>
                    <Grid sx={{
                        display: ' flex',
                        justifyContent: 'flex-end'
                    }}>
                        <NavLink to={"/events"}><Button
                            variant="contained"
                            color="primary"
                            sx={{width: '200px', fontSize: '16px', background: "#FFD050", color: "#000"}}>
                            ادامه مطلب
                        </Button></NavLink>
                    </Grid>
                </Grid>

            </Grid>
        </Box>

    )
        ;
};

export default LastEvent;


// <Grid container sx={{display: "flex", flexWrap: "wrap",backgroundPosition: "center"
// }} py={5}>
//
//     <Grid sx={{flex: "0 0 auto", width: "50%"}}>
//         <Grid>
//             <Typography
//                 data-aos="fade-right"
//                 data-aos-duration="2000"
//                 data-aos-delay="000"
//             >
//                 ایونت یلدا
//             </Typography>
//             <Typography>
//                 It is a long established fact that a reader will be distracted by the readable content of a page
//                 when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal
//                 distribution of letters, as opposed to using 'Content here, content here', making it look like
//                 readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as
//                 their default model text, and a search for 'lorem ipsum' will uncover many web sites still in
//                 their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on
//                 purpose (injected humour and the like).
//             </Typography>
//         </Grid>
//     </Grid>
//     <Grid sx={{
//         flex: "0 0 auto",
//         width: "50%",
//         backgroundImage: `url(${ImagesEvent})`,
//         backgroundPosition: "center"
//     }}>
//
//     </Grid>
//
// </Grid>


//
// <Grid sx={{display:"flex",flexDirection:"row",px:5,border:'1px solid grey',m:2,p:9,gap:2}}>
//     <Grid sx={{overflow:"hidden",width:"40%"}}>
//         <img src={ImagesEvent} sx={{width:"100%",height:"100%",objectFit:"cover"}}/>
//     </Grid>
//     <Grid sx={{width:"60%"}}>
//         <Typography variant={'h4'} sx={{fontWeight:800}} data-aos="fade-right"
//                     data-aos-duration="2000"
//                     data-aos-delay="000">ایــونـت یلــدا
//         </Typography>
//         <Typography variant={'h5'} sx={{color:"#592EA9",fontWeight:800}}>
//             شرکت پیشرو پارسیان
//         </Typography>
//         <Typography sx={{color:"#6D6E76"}}>
//             فقط کافیست ورزش مورد نظر را جستجو کنید تا از اطلاعات متنوع و کامل کلاس های مختلف رشته مدنظر مطلع
//             شوید. فقط کافیست ورزش مورد نظر را جستجو کنید تا از اطلاعات متنوع و کامل کلاس های مختلف رشته
//             مدنظر مطلع شوید. فقط کافیست ورزش مورد نظر را جستجو کنید تا از اطلاعات متنوع و کامل کلاس های
//             مختلف رشته مدنظر مطلع شوید.
//             فقط کافیست ورزش مورد نظر را جستجو کنید تا از اطلاعات متنوع و کامل کلاس های مختلف رشته مدنظر مطلع
//             شوید. فقط کافیست ورزش مورد نظر را جستجو کنید تا از اطلاعات متنوع و کامل کلاس های مختلف رشته
//             مدنظر مطلع شوید.فقط کافیست ورزش مورد نظر را جستجو کنید تا از اطلاعات متنوع و کامل کلاس های مختلف
//             رشته مدنظر مطلع شوید. فقط کافیست ورزش مورد نظر را جستجو کنید تا از اطلاعات متنوع و کامل کلاس های
//             مختلف رشته مدنظر مطلع شوید.
//         </Typography>
//         <Button variant={"contained"} sx={{background:"#FFD050",color:"#000"}}>ادامه مطلب</Button>
//     </Grid>
// </Grid>